"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Project = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-float"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/is-array"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _Erp = require("./Erp");
var _ProjectRow = require("./ProjectRow");
var _Warning = require("./Warning");
var _RowSlot = require("./RowSlot");
var _Rule = require("./Rule");
var _api = require("../api");
var _patterns = require("../patterns");
var prjPropertyToKeep = ['headerCatalog', 'currentVersion', 'points', 'hWalls', 'measures', 'pricesIncrease'];
Date.prototype.toInt = function () {
  return this.getDate() + (this.getMonth() + 1) * 100 + this.getFullYear() * 10000;
};
var Project = /*#__PURE__*/function () {
  function Project() {
    (0, _classCallCheck2["default"])(this, Project);
    this.id = 0;
    this.iderp = '';
    this.iderp2 = '';
    this.iderp3 = '';
    this.changed = false;
    this.isopen = false;
    this.des = '';
    this.info = '';
    this.share = 0;
    this.sharedes = '';
    this.nuovo = true;
    this.currentrow = -1;
    this.uniqueid = 0;
    this.manUniqueid = 3000;
    this.history = [];
    this.rows = [];
    this.envWall = null;
    this.jobs = [];
    this.tops = null;
    this.eval3dtops = {};
    this.eval3dwall = {};
    this.boxTops = [];
    this.jobImages = [];
    this.customercod = "";
    this.orderaddress = [{}];
    this.shippingaddress = [{}];
    this.delivery = {
      cod: null,
      prstone: null,
      pr: null
    };
    this.discountamount = 0;
    this.chainid = "";
    this.listid = null;
    this.campaign = null;
    this.campaignDes = null;
    this.headernote1 = "";
    this.headernote2 = "";
    this.deliverynote = "";
    this.isoffer = 0;
    this.vheadernext = [];
    this.engine_views = [];
    this.warnings = [];
    this.globalWarning = [];
    this.status = 'UNASSIGNED';
    this.priceDate = new Date().toInt();
    this.data = new Date().toInt();
    this.user = null;
    this.userdes = null;
    this.usermail = null;
    this.usertel = null;
    this.shop = null;
    this.shopid = null;
    this.shopdes = null;
    this.owner = null;
    this.ownermail = null;
    this.ownertel = null;
    this.ownerdes = null;
    this.sellerid = null;
    this.sellerdes = null;
    this.sellermail = null;
    this.sellertel = null;
    this.sellerlevel = null;
    this.extra1 = null;
    this.extra2 = null;
    this.extra3 = null;
    this.extra4 = null;
    this.extra5 = null;
    this.renderPrints = [];
    this.totale = null;
    this.idfromunique = this.getIndexByUID;
    this.remove = this.removeRowByIndex;
    this.getrow = this.getCurrentRow;
    this.forcegetarow = this.forceActiveRow;
    this.photoJSON = null;
    this.priceIncrease = 1;
    this.roomHeight = null;
    this.toReval = false;
    this.img = null;
    this.customerFields = {};
    this.map2D = null;
    this.currentVersion = null;
    this.shopemail = null;
    this.sellerfirstname = null;
    this.sellerlastname = null;
    this.sellercensoredlastname = null;
    this.deliveryprice = null;
    this.globalPriceExtras = null;
    this.id = 0;
    this.iderp = '';
    this.iderp2 = '';
    this.iderp3 = '';
    this.changed = false;
    this.isopen = false;
    this.des = '';
    this.info = '';
    this.share = 0;
    this.sharedes = '';
    this.nuovo = true;
    this.currentrow = -1;
    this.uniqueid = 0;
    this.manUniqueid = 3000;
    this.history = [];
    this.rows = [];
    this.envWall = null;
    this.jobs = [];
    this.tops = null;
    this.eval3dtops = {};
    this.eval3dwall = {};
    this.boxTops = [];
    this.jobImages = [];
    this.customercod = "";
    this.orderaddress = [{}];
    this.shippingaddress = [{}];
    this.delivery = {
      cod: null,
      pr: null,
      prstone: null
    };
    this.discountamount = 0;
    this.chainid = "";
    this.listid = null;
    this.campaign = null;
    this.campaignDes = null;
    this.headernote1 = "";
    this.headernote2 = "";
    this.deliverynote = "";
    this.isoffer = 0;
    this.vheadernext = [];
    this.engine_views = [];
    this.warnings = [];
    this.globalWarning = [];
    this.status = 'UNASSIGNED';
    this.priceDate = new Date().toInt();
    this.data = new Date().toInt();
    this.user = null;
    this.userdes = null;
    this.usermail = null;
    this.usertel = null;
    this.shop = null;
    this.shopid = null;
    this.shopdes = null;
    this.owner = null;
    this.ownermail = null;
    this.ownertel = null;
    this.ownerdes = null;
    this.sellerid = null;
    this.sellerdes = null;
    this.sellermail = null;
    this.sellertel = null;
    this.sellerlevel = null;
    this.extra1 = null;
    this.extra2 = null;
    this.extra3 = null;
    this.extra4 = null;
    this.extra5 = null;
    this.renderPrints = [];
    this.totale = this.prjTotal;
    this.idfromunique = this.getIndexByUID;
    this.remove = this.removeRowByIndex;
    this.getrow = this.getCurrentRow;
    this.forcegetarow = this.forceActiveRow;
    this.photoJSON = null;
    this.priceIncrease = 1;
    this.roomHeight = null;
    this.toReval = false;
    this.customerFields = {};
    this.currentVersion = null;
    this.shopemail = null;
    this.sellerfirstname = null;
    this.sellerlastname = null;
    this.sellercensoredlastname = null;
    this.deliveryprice = 0;
    this.globalPriceExtras = {
      erpRowPriceMultiplier: 1,
      completeProjectNetPrice: 0,
      assemblyCosts: 0,
      completeProjectPrice: 0,
      totalDiscount1: 0,
      totalDiscount2: 0
    };
  }
  (0, _createClass2["default"])(Project, [{
    key: "createnewrow",
    value: function createnewrow() {
      return Project.createNewRow();
    }
  }, {
    key: "isProjectRow",
    value: function isProjectRow(row) {
      var _context;
      return !!(0, _find["default"])(_context = this.rows).call(_context, function (r) {
        return r === row;
      });
    }
  }, {
    key: "prjTotal",
    value: function prjTotal() {
      var withTaxes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var withCamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var withDeliver = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var withDisc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var tot = 0;
      if (this.rows) {
        var _context2;
        (0, _forEach["default"])(_context2 = this.rows).call(_context2, function (row) {
          tot += row.getTotal(withTaxes, withCamp, true);
        });
      }
      if (withDeliver) tot += (this.delivery.pr || 0) + (this.delivery.prstone || 0);
      if (withDisc) tot -= this.discountamount;
      if (tot < 0) tot = 0;
      return tot;
    }
  }, {
    key: "prjNetTotal",
    value: function prjNetTotal(_ref) {
      var _ref$withTaxes = _ref.withTaxes,
        withTaxes = _ref$withTaxes === void 0 ? false : _ref$withTaxes,
        _ref$withCamp = _ref.withCamp,
        withCamp = _ref$withCamp === void 0 ? false : _ref$withCamp;
      var tot = 0;
      if (this.rows) {
        var _context3;
        (0, _forEach["default"])(_context3 = this.rows).call(_context3, function (row) {
          tot += row.getTotal(withTaxes, withCamp, true);
        });
      }
      tot = tot * (1 - this.globalPriceExtras.totalDiscount1) * (1 - this.globalPriceExtras.totalDiscount2) + this.deliveryprice + this.globalPriceExtras.assemblyCosts;
      return tot;
    }
  }, {
    key: "getWeight",
    value: function getWeight() {
      var tot = 0;
      if (this.rows) {
        var _context4;
        (0, _forEach["default"])(_context4 = this.rows).call(_context4, function (row) {
          tot += row.getWeight();
        });
      }
      return tot;
    }
  }, {
    key: "getVolume",
    value: function getVolume() {
      var tot = 0;
      if (this.rows) {
        var _context5;
        (0, _forEach["default"])(_context5 = this.rows).call(_context5, function (row) {
          tot += row.getVolume();
        });
      }
      return tot;
    }
  }, {
    key: "getIndexByUID",
    value: function getIndexByUID(uid) {
      for (var i = 0; i < this.rows.length; i++) {
        var row = this.rows[i];
        if (row.uniqueid === uid) return i;
      }
      return -1;
    }
  }, {
    key: "removeRowByIndex",
    value: function removeRowByIndex(index) {
      if (this.rows[index]) {
        return this.removeRowByUid(this.rows[index].uniqueid);
      }
      return false;
    }
  }, {
    key: "removeRowByUid",
    value: function removeRowByUid(uid) {
      var removed = false;
      var rowToRemove = this.getRowByUid(uid);
      if (rowToRemove) {
        var index = -1;
        if (rowToRemove.clPlacerChilds && rowToRemove.clPlacerChilds.length > 0) {
          var rowsToRemove = this.getRowsChildsPlacers(rowToRemove);
          if (rowToRemove.father) {
            var father = this.getRowByUid(rowToRemove.father.idRow);
            if (father) {
              for (var i = 0; i < father.clPlacerChilds.length; i++) {
                if (father.clPlacerChilds[i].idRow == rowToRemove.uniqueid) {
                  var _context6;
                  (0, _splice["default"])(_context6 = father.clPlacerChilds).call(_context6, i, 1);
                }
              }
            }
          }
          rowsToRemove.push(rowToRemove);
          for (var _i = 0; _i < rowsToRemove.length; _i++) {
            var _context7, _context8;
            index = (0, _indexOf["default"])(_context7 = this.rows).call(_context7, rowsToRemove[_i]);
            (0, _splice["default"])(_context8 = this.rows).call(_context8, index, 1);
          }
        } else if (rowToRemove.father) {
          var _context10, _context11;
          var _father = this.getRowByUid(rowToRemove.father.idRow);
          if (_father) {
            for (var _i2 = 0; _i2 < _father.clPlacerChilds.length; _i2++) {
              if (_father.clPlacerChilds[_i2].idRow == rowToRemove.uniqueid) {
                var _context9;
                (0, _splice["default"])(_context9 = _father.clPlacerChilds).call(_context9, _i2, 1);
              }
            }
          }
          index = (0, _indexOf["default"])(_context10 = this.rows).call(_context10, rowToRemove);
          (0, _splice["default"])(_context11 = this.rows).call(_context11, index, 1);
        } else {
          var _context12, _context13;
          index = (0, _indexOf["default"])(_context12 = this.rows).call(_context12, rowToRemove);
          (0, _splice["default"])(_context13 = this.rows).call(_context13, index, 1);
        }
        if (index > 0) this.currentrow = index - 1;else this.currentrow = 0;
        removed = true;
      } else {
        removed = false;
      }
      return removed;
    }
  }, {
    key: "getRowsChildsPlacers",
    value: function getRowsChildsPlacers(row) {
      var rowsChildsPlacers = [];
      if (row.clPlacerChilds) {
        for (var i = 0; i < row.clPlacerChilds.length; i++) {
          var rowChild = this.getRowByUid(row.clPlacerChilds[i].idRow);
          rowsChildsPlacers.push(rowChild);
          rowsChildsPlacers.push.apply(rowsChildsPlacers, (0, _toConsumableArray2["default"])(this.getRowsChildsPlacers(rowChild)));
        }
      }
      return rowsChildsPlacers;
    }
  }, {
    key: "savePhotoMatch",
    value: function savePhotoMatch(photoJSON) {
      this.photoJSON = photoJSON;
    }
  }, {
    key: "forceValidRow",
    value: function forceValidRow() {
      if (this.currentrow < 0 || this.currentrow >= this.rows.length) this.currentrow = 0;
      if (this.rows.length === 0) {
        this.currentrow = -1;
        return;
      }
      if (this.rows[this.currentrow].auto === true) {
        var j = this.currentrow;
        for (var i = 0; i < this.rows.length; i++) {
          j++;
          if (j >= this.rows.length) j = 0;
          if (this.rows[j].auto !== true) {
            this.currentrow = j;
            return;
          }
        }
        this.currentrow = -1;
      }
    }
  }, {
    key: "getCurrentRow",
    value: function getCurrentRow() {
      this.forceValidRow();
      if (this.currentrow >= 0) {
        var row = this.rows[this.currentrow];
        return row;
      }
      return null;
    }
  }, {
    key: "forceActiveRow",
    value: function forceActiveRow(id) {
      if (id !== undefined && this.currentrow < 0 || this.currentrow >= this.rows.length) this.currentrow = id;
      if (this.currentrow < 0 || this.currentrow >= this.rows.length) {
        this.currentrow = 0;
      }
      return this.getCurrentRow();
    }
  }, {
    key: "addNewRow",
    value: function addNewRow() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _ProjectRow.rowTypes.BOX;
      var newRow = new _ProjectRow.ProjectRow(null);
      if (typeof type === 'string') {
        type = _ProjectRow.rowTypes[type];
      }
      switch (type) {
        case 0:
          newRow.uniqueid = this.uniqueid;
          if (!this.uniqueid) this.uniqueid = 1;else this.uniqueid++;
          this.rows.push(newRow);
          this.currentrow = this.rows.length - 1;
          break;
        case 3:
          if (!this.manUniqueid) this.manUniqueid = 3000;else this.manUniqueid++;
          newRow.uniqueid = this.manUniqueid;
          newRow.local = true;
          this.rows.push(newRow);
          this.currentrow = this.rows.length - 1;
          break;
        default:
          console.warn("Provide \"add new project row\" in dproject.js for " + _ProjectRow.rowTypes[type]);
          break;
      }
      return newRow;
    }
  }, {
    key: "addDuplicatedRow",
    value: function addDuplicatedRow() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _ProjectRow.rowTypes.BOX;
      var json = arguments.length > 1 ? arguments[1] : undefined;
      var newRow = new _ProjectRow.ProjectRow(json);
      if (typeof type === 'string') {
        type = _ProjectRow.rowTypes[type];
      }
      switch (type) {
        case 0:
          newRow.uniqueid = this.uniqueid;
          if (!this.uniqueid) this.uniqueid = 1;else this.uniqueid++;
          this.rows.push(newRow);
          break;
        case 3:
          if (!this.manUniqueid) this.manUniqueid = 3000;else this.manUniqueid++;
          newRow.uniqueid = this.manUniqueid;
          newRow.local = true;
          this.rows.push(newRow);
          break;
        default:
          console.warn("Provide \"add new project row\" in dproject.js for " + _ProjectRow.rowTypes[type]);
          break;
      }
      return newRow;
    }
  }, {
    key: "addNewRuledRow",
    value: function addNewRuledRow(ruledRow) {
      var row = new _ProjectRow.ProjectRow(ruledRow);
      row.uniqueid = this.uniqueid;
      if (!this.uniqueid) this.uniqueid = 1;else this.uniqueid++;
      this.rows.push(row);
      this.currentrow = this.rows.length - 1;
      return row;
    }
  }, {
    key: "getRowByUid",
    value: function getRowByUid(uid) {
      for (var i = 0; i < this.rows.length; i++) {
        if (this.rows[i].uniqueid === uid) {
          return this.rows[i];
        }
      }
    }
  }, {
    key: "getFreeClassicPlacerSlot",
    value: function getFreeClassicPlacerSlot() {
      var freeRowsSlots = [];
      for (var i = 0; i < this.rows.length; i++) {
        freeRowsSlots.push.apply(freeRowsSlots, (0, _toConsumableArray2["default"])(this.rows[i].getFreeRowSlots()));
      }
      return freeRowsSlots;
    }
  }, {
    key: "getClassicPlacerByRowIDSlot",
    value: function getClassicPlacerByRowIDSlot(idRow, idSlot) {
      var classicPlacer = null;
      for (var i = 0; i < this.rows.length && !classicPlacer; i++) {}
      return classicPlacer;
    }
  }, {
    key: "setJobs",
    value: function setJobs(data) {
      this.jobs = data;
    }
  }, {
    key: "saveJobImages",
    value: function saveJobImages(viewPars, resolution, camera) {
      if (this.jobs) {
        var px = resolution;
        var py = px;
        var fov = 0;
        var ax = 45;
        var ay = 45;
        if (viewPars && viewPars.length > 0) {
          fov = (0, _parseFloat2["default"])(viewPars.ex(";", 1));
          ax = (0, _parseFloat2["default"])(viewPars.ex(";", 2));
          ay = (0, _parseFloat2["default"])(viewPars.ex(";", 3));
          px = (0, _parseFloat2["default"])(viewPars.ex(";", 4));
          py = (0, _parseFloat2["default"])(viewPars.ex(";", 5));
        }
        this.jobImages = [];
      }
    }
  }, {
    key: "setActiveRowByIndex",
    value: function setActiveRowByIndex(index) {
      if (index < 0 || index >= this.rows.length) return false;
      this.currentrow = index;
      this.getCurrentRow().isloaditem = false;
      return true;
    }
  }, {
    key: "setActiveRowByRow",
    value: function setActiveRowByRow(row) {
      var id = -1;
      for (var i = 0; i < this.rows.length && id === -1; i++) {
        if (this.rows[i] === row) id = i;
      }
      if (id < 0) return;
      this.currentrow = id;
      this.getCurrentRow().isloaditem = false;
    }
  }, {
    key: "setActiveRowByUniqueID",
    value: function setActiveRowByUniqueID(uniqueid) {
      var id = -1;
      for (var i = 0; i < this.rows.length && id === -1; i++) {
        if (this.rows[i].uniqueid === uniqueid) {
          id = i;
        }
      }
      if (id < 0) return;
      this.currentrow = id;
      this.getrow().isloaditem = false;
    }
  }, {
    key: "boxByHeightStrip",
    value: function boxByHeightStrip() {
      var altezze = [];
      if (this.rows) {
        altezze.push({
          h1: -100,
          h2: 899.9,
          box: []
        });
        altezze.push({
          h1: 899.9,
          h2: 5000,
          box: []
        });
        for (var i = 0; i < this.rows.length; i++) {
          var sa = this.rows[i].pa;
          if (!this.rows[i].wallItem && !this.rows[i].auto) {
            var found = false;
            for (var j = 0; j < altezze.length; j++) {
              if (sa > altezze[j].h1 && sa <= altezze[j].h2) {
                found = true;
                altezze[j].box.push(i);
                j = altezze.length + 1;
              }
            }
            if (!found) {
              var altezza = {
                h1: 0,
                box: []
              };
              console.warn('sort base height ');
              altezza.h1 = sa;
              altezza.box.push(i);
              altezze.push(altezza);
            }
          }
        }
      }
      return altezze;
    }
  }, {
    key: "getAngleBaric",
    value: function getAngleBaric(baricentrox, baricentroz, row) {
      var px = row.pl;
      var pz = row.pp;
      var dx = px - baricentrox;
      var dz = pz - baricentroz;
      return Math.atan2(dx, -dz);
    }
  }, {
    key: "sortLeftRight",
    value: function sortLeftRight(rowList, startCount, options) {
      var testoDump = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var baricentrox = arguments.length > 4 ? arguments[4] : undefined;
      var baricentroz = arguments.length > 5 ? arguments[5] : undefined;
      if (!rowList) return;
      if (rowList.length <= 0) return;
      for (var i = 0; i < rowList.length; i++) {
        var a1 = this.getAngleBaric(baricentrox, baricentroz, this.rows[rowList[i]]);
        this.rows[rowList[i]].testobox = "" + Math.round(a1 * 100) / 100;
        for (var j = i + 1; j < rowList.length; j++) {
          var a2 = this.getAngleBaric(baricentrox, baricentroz, this.rows[rowList[j]]);
          this.rows[rowList[j]].testobox = "" + Math.round(a2 * 100) / 100;
          if (a2 < a1) {
            var tmp = rowList[i];
            rowList[i] = rowList[j];
            rowList[j] = tmp;
            a1 = this.getAngleBaric(baricentrox, baricentroz, this.rows[rowList[i]]);
          }
        }
      }
      var ct = startCount;
      for (var _i3 = 0; _i3 < rowList.length; _i3++) {
        var rowAtt = this.rows[rowList[_i3]];
        var skipMe = false;
        if (options.skipModel) {
          var skipModel = [];
          skipModel = options.skipModel;
          for (var skMod = 0; skMod < skipModel.length; skMod++) {
            if (skipModel[skMod] === rowAtt.model) {
              skipMe = true;
            }
          }
        }
        if (skipMe) {
          rowAtt.testobox = "SKIP";
        } else {
          rowAtt.testobox = "" + ct;
          ct++;
        }
      }
      return ct;
    }
  }, {
    key: "getBarycenter",
    value: function getBarycenter(rowList) {
      var baricentrox = 0;
      var baricentroz = 0;
      var oppositePresent = false;
      for (var i = 0; i < rowList.length; i++) {
        if (!rowList[i].wallItem && !rowList[i].auto) {
          var ang = -rowList[i].axz * Math.PI / 180;
          baricentrox += rowList[i].pl;
          baricentroz += rowList[i].pp;
          baricentrox += rowList[i].pl + rowList[i].l * Math.cos(ang) + rowList[i].p * Math.sin(ang);
          baricentroz += rowList[i].pp + rowList[i].l * Math.sin(ang) + rowList[i].p * Math.cos(ang);
          if (rowList[i].axz < -90 || rowList[i].axz >= 90) oppositePresent = true;
        }
      }
      baricentrox /= 2 * rowList.length;
      baricentroz /= 2 * rowList.length;
      if (!oppositePresent) baricentroz += 5000;
      return {
        x: baricentrox,
        z: baricentroz
      };
    }
  }, {
    key: "addHeaderVariant",
    value: function addHeaderVariant(cod, des) {
      cod = cod.toUpperCase();
      for (var i = 0; i < this.vheadernext.length; i++) {
        if (this.vheadernext[i].cod === cod) {
          this.vheadernext[i].des = des;
          return;
        }
      }
      var newVal = {};
      newVal.des = des;
      newVal.cod = cod;
      this.vheadernext.push(newVal);
    }
  }, {
    key: "addHeaderMultipleVariants",
    value: function addHeaderMultipleVariants(varList) {
      if (varList) {
        var splt = varList.split(';');
        for (var i = 0; i < splt.length; i++) {
          this.addHeaderVariant(splt[i].ex("=", 1), splt[i].ex("=", 2));
        }
      }
    }
  }, {
    key: "addWarning",
    value: function addWarning(type, level, description, data) {
      if (!this.warnings) this.warnings = [];
      var warn = new _Warning.Warning(type, level, description, data);
      this.warnings.push(warn);
    }
  }, {
    key: "addBoxesIntersectionWarning",
    value: function addBoxesIntersectionWarning(data) {
      this.addWarning(_Warning.WarningTypes.BOX_INTERSECTION, 2, "Collision", data);
    }
  }, {
    key: "addWallCollisionWarning",
    value: function addWallCollisionWarning(data) {
      this.addWarning(_Warning.WarningTypes.WALL_INTERSECTION, 2, "Wall Collision", data);
    }
  }, {
    key: "addNotInsertedWarning",
    value: function addNotInsertedWarning(data) {
      this.addWarning(_Warning.WarningTypes.ITEM_NOT_INSERTED, 4, "Item non inserted", data);
    }
  }, {
    key: "addFarFromOriginWarning",
    value: function addFarFromOriginWarning(data) {
      this.addWarning(_Warning.WarningTypes.FAR_FROM_ORIGIN, 5, "Item far from origin", data);
    }
  }, {
    key: "addItemWarning",
    value: function addItemWarning(data) {
      var level = 5;
      if (data.level) {
        level = data.level;
      }
      this.addWarning(_Warning.WarningTypes.ITEM_WARNING, level, "Item far from origin", data);
    }
  }, {
    key: "removeWarningsByType",
    value: function removeWarningsByType(type) {
      if (this.warnings) {
        for (var i = this.warnings.length - 1; i >= 0; i--) {
          var _context14;
          if (this.warnings[i].type === type) (0, _splice["default"])(_context14 = this.warnings).call(_context14, i, 1);
        }
      }
    }
  }, {
    key: "removeWallWarnings",
    value: function removeWallWarnings() {
      this.removeWarningsByType(_Warning.WarningTypes.BOX_INTERSECTION);
      this.removeWarningsByType(_Warning.WarningTypes.WALL_INTERSECTION);
      this.removeWarningsByType(_Warning.WarningTypes.ITEM_NOT_INSERTED);
      this.removeWarningsByType(_Warning.WarningTypes.FAR_FROM_ORIGIN);
      this.removeWarningsByType(_Warning.WarningTypes.ITEM_WARNING);
    }
  }, {
    key: "getWarnings",
    value: function getWarnings() {
      return this.warnings;
    }
  }, {
    key: "getWarningsTable",
    value: function getWarningsTable() {
      var warn = this.warnings;
      var warnTable = [];
      if (warn) {
        for (var i = 0; i < warn.length; i++) {
          var warningRow = new _Warning.WarningRow();
          switch (warn[i].type) {
            case _Warning.WarningTypes.BOX_INTERSECTION:
              warningRow.type = "Collision";
              warningRow.level = warn[i].level;
              warningRow.from = warn[i].data.id1;
              warningRow.to = warn[i].data.id2;
              warningRow.description = warn[i].description;
              warningRow.description += " BoxID = " + warn[i].data.id1 + ", " + warn[i].data.id2;
              break;
            case _Warning.WarningTypes.WALL_INTERSECTION:
              warningRow.type = "Wall intersection";
              warningRow.level = warn[i].level;
              warningRow.from = warn[i].data.id1;
              warningRow.to = warn[i].data.id2;
              warningRow.description = warn[i].description;
              warningRow.description += " BoxID = " + warn[i].data.idBox + ", WallID =" + warn[i].data.idWall;
              break;
            case _Warning.WarningTypes.ITEM_NOT_INSERTED:
              warningRow.type = "Item not inserted";
              warningRow.level = warn[i].level;
              warningRow.from = warn[i].data.id;
              warningRow.description = warn[i].description;
              warningRow.description += " BoxID = " + warn[i].data.idBox;
              break;
            case _Warning.WarningTypes.FAR_FROM_ORIGIN:
              warningRow.type = "Item far from origin";
              warningRow.level = warn[i].level;
              warningRow.idItem = warn[i].data.idItem;
              warningRow.isRow = warn[i].data.isRow;
              warningRow.description = warn[i].description;
              warningRow.description += " ItemID = " + warn[i].data.idItem;
              break;
            case _Warning.WarningTypes.ITEM_WARNING:
              warningRow.type = "Item Catalog Error";
              warningRow.level = warn[i].level;
              warningRow.from = warn[i].data.idItem;
              warningRow.isRow = warn[i].data.isRow;
              warningRow.description = warn[i].data.description;
              break;
          }
          warningRow.rawWarn = warn[i];
          warnTable.push(warningRow);
        }
      }
      return warnTable;
    }
  }, {
    key: "mergeJson",
    value: function mergeJson(json) {
      var _this = this;
      if (json) {
        var _loop = function _loop() {
          if (!_this.hasOwnProperty(k)) {
            if ((0, _indexOf["default"])(prjPropertyToKeep).call(prjPropertyToKeep, k) > -1) {
              _this[k] = json[k];
            } else {
              console.warn('Property %c' + k + '%c of project is deleted', 'color: blue', 'color: inherit');
            }
          } else {
            if ((0, _typeof2["default"])(json[k]) === 'object') {
              if (k === 'rows') {
                var tempRows = _this.rows;
                var rows = json[k];
                _this.rows = [];
                var _loop2 = function _loop2(i) {
                  var row;
                  var sameRow = (0, _find["default"])(tempRows).call(tempRows, function (r) {
                    return r.uniqueid === rows[i].uniqueid;
                  });
                  if (sameRow) {
                    sameRow.mergeJson(rows[i]);
                    row = sameRow;
                  } else row = new _ProjectRow.ProjectRow(rows[i]);
                  _this.rows.push(row);
                };
                for (var i = 0; i < rows.length; i++) {
                  _loop2(i);
                }
              } else {
                _this[k] = json[k];
              }
            } else {
              _this[k] = json[k];
            }
          }
        };
        for (var k in json) {
          _loop();
        }
      }
      this.convertOldHystory();
    }
  }, {
    key: "getJson",
    value: function getJson() {
      var _context15;
      var copyPrj = JSON.parse((0, _stringify["default"])(this));
      (0, _forEach["default"])(_context15 = copyPrj.rows).call(_context15, function (row) {
        if (row.rule) delete row.rule;
        if (row.placer) {
          var _context16;
          (0, _forEach["default"])(_context16 = row.placer).call(_context16, function (placer) {
            delete placer.rule;
          });
        }
      });
      return copyPrj;
    }
  }, {
    key: "lmthead",
    value: function lmthead() {
      return {
        header: '',
        id: this.id,
        info: this.info,
        rows: [],
        reval: null
      };
    }
  }, {
    key: "getEvalRowsData",
    value: function getEvalRowsData(rows) {
      var _this2 = this;
      var data = this.lmthead();
      (0, _forEach["default"])(rows).call(rows, function (r) {
        if (!_this2.isProjectRow(r)) throw new Error('Not project rows');
        if (r.auto) return;
        if (r._configure && r.job) {
          var x = Project.baserowdata(r);
          x.pann = r.job.pan;
          data.rows.push(x);
        }
      });
      return data;
    }
  }, {
    key: "getEvalProjectData",
    value: function getEvalProjectData() {
      var changes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var data = this.getEvalRowsData(this.rows);
      if (changes) {
        data.reval = changes.getRevalData();
        for (var i = 0; i < data.rows.length; i++) {
          if (!changes.applyToSelected) data.rows[i].toreval = 1;else {
            for (var j = 0; j < changes.items.length; j++) {
              if (data.rows[i].id === changes.items[j].uniqueid) {
                data.rows[i].toreval = 1;
                break;
              }
            }
          }
        }
      }
      return data;
    }
  }, {
    key: "setEvalProjectData",
    value: function setEvalProjectData(response) {
      var _a;
      for (var i = this.rows.length - 1; i >= 0; i--) {
        var _context17;
        if (this.rows[i].auto) (0, _splice["default"])(_context17 = this.rows).call(_context17, i, 1);
      }
      this.tops = null;
      if (!response) return;
      this.tops = response.obj;
      this.boxTops = response.boxTops;
      this.globalWarning = response.globalWarning;
      if (response.finals && response.finals.length > 0) {
        for (var _i4 = 0; _i4 < response.finals.length; _i4++) {
          var id = response.finals[_i4].id;
          if (id === undefined) {
            response.finals[_i4].id = 0;
            id = response.finals[_i4].id;
          }
          var row = this.getRowByUid(id);
          if (row) {
            row.eval3dris = response.finals[_i4].eval3dris;
            row.reg = response.finals[_i4].reg;
            if (((_a = row === null || row === void 0 ? void 0 : row.rule) === null || _a === void 0 ? void 0 : _a.reg) && row.rule.reg != row.reg) row.rule = null;
            row.job = response.finals[_i4].job;
            row.model = response.finals[_i4].model;
            row.cmodel = response.finals[_i4].cmodel;
            row.extraEval = response.finals[_i4].extraEval;
            if (response.finals[_i4].classicPlacer) {
              row.classicPlacer = response.finals[_i4].classicPlacer;
            }
            if (response.finals[_i4].newposition) {
              var _response$finals$_i4$ = response.finals[_i4].newposition,
                pl = _response$finals$_i4$.pl,
                pa = _response$finals$_i4$.pa,
                pp = _response$finals$_i4$.pp;
              row.pl = pl || row.pl;
              row.pa = pa || row.pa;
              row.pp = pp || row.pp;
            }
            (0, _api.elabMagicLink)(row.extraEval);
            (0, _api.grabFromInfo)(row, response.finals[_i4].rinfo);
            row.setErp(response.finals[_i4].erp);
            if (row.erp) {
              if (row.erp.length > 0) {
                row.cod = row.erp[0].cod;
              }
            }
          }
        }
      }
      if (response.topbom && response.topbom.length > 0) {
        for (var _i5 = 0; _i5 < response.topbom.length; _i5++) {
          var dd = response.topbom[_i5];
          var r = {
            uniqueid: 1000 + _i5,
            pl: 0,
            pa: 0,
            pp: 0,
            axz: 0,
            axy: 0,
            ayz: 0,
            nl: 0,
            na: 0,
            np: 0,
            ul: 0,
            ua: 0,
            up: 0,
            auto: true,
            _configure: false,
            catalog: dd.catalog,
            img: dd.img,
            cod: "#TOP",
            des: "Automatic"
          };
          var newRow = new _ProjectRow.ProjectRow(r);
          newRow.setErp(dd.erp);
          this.rows.push(newRow);
        }
      }
    }
  }, {
    key: "pushHistory",
    value: function pushHistory(catalog, model) {
      var _context18, _context21;
      if (!catalog) throw 'history need a catalog data';
      if (!model) throw 'history need a model data';
      var sameCatalogRow = (0, _find["default"])(_context18 = this.history).call(_context18, function (r) {
        return r.catalog === catalog;
      });
      var newHistoryRow = null;
      if (!sameCatalogRow) {
        this.history.push({
          catalog: null,
          models: [],
          currentModel: null
        });
        newHistoryRow = this.history[this.history.length - 1];
        newHistoryRow.catalog = catalog;
      } else {
        var _context19, _context20;
        var index = (0, _findIndex["default"])(_context19 = this.history).call(_context19, function (r) {
          return r === sameCatalogRow;
        });
        (0, _splice["default"])(_context20 = this.history).call(_context20, index, 1);
        this.history.push(sameCatalogRow);
        newHistoryRow = sameCatalogRow;
      }
      if (!model.cmodel) throw 'cModel code is not defined';
      if (!model.cod) throw 'Model code is not defined';
      if (!model.header) console.warn('Model header is not defined');
      model = {
        cmodel: model.cmodel,
        cod: model.cod,
        des: model.des || null,
        header: model.header || ''
      };
      var sameModelRow = (0, _find["default"])(_context21 = newHistoryRow.models).call(_context21, function (r) {
        return r.cmodel === model.cmodel;
      });
      if (!sameModelRow) newHistoryRow.models.push(model);else (0, _assign["default"])(sameModelRow, model);
      newHistoryRow.currentModel = model;
    }
  }, {
    key: "getLastHistoryEntry",
    value: function getLastHistoryEntry() {
      return this.history[this.history.length - 1];
    }
  }, {
    key: "convertOldHystory",
    value: function convertOldHystory() {
      var _this3 = this;
      var oldHistory = this.history;
      if (!(0, _isArray["default"])(oldHistory)) throw 'Loaded history is not an array';
      if (oldHistory.length > 0) {
        this.history = [];
        var _loop3 = function _loop3() {
          var _context22;
          var oldHistoryRow = oldHistory[i];
          if (!oldHistoryRow.data && !oldHistoryRow.des) {
            _this3.history = oldHistory;
            return "break";
          }
          if (!oldHistoryRow.catalog) throw 'Old history row has not a defined catalog';
          var sameCatalogRow = (0, _find["default"])(_context22 = _this3.history).call(_context22, function (r) {
            return r.catalog === oldHistoryRow.catalog;
          });
          var newHistoryRow = null;
          if (!sameCatalogRow) {
            _this3.history.push({
              catalog: null,
              models: [],
              currentModel: null
            });
            newHistoryRow = _this3.history[_this3.history.length - 1];
            newHistoryRow.catalog = oldHistoryRow.catalog;
          } else {
            newHistoryRow = sameCatalogRow;
          }
          var model = null;
          if (oldHistoryRow.data && oldHistoryRow.data.length > 0) {
            var _context23;
            var tempModel = (0, _find["default"])(_context23 = oldHistoryRow.data).call(_context23, function (r) {
              return r.mode === 2;
            });
            if (tempModel && tempModel.data) {
              if (!tempModel.data.cmodel) throw 'cModel code is not defined';
              if (!tempModel.data.model) throw 'Model code is not defined';
              model = {
                des: oldHistoryRow.cur && oldHistoryRow.cur.des ? oldHistoryRow.cur.des : null,
                cmodel: oldHistoryRow.cur.cod,
                cod: tempModel.data.model,
                header: tempModel.data.defaultvar || ''
              };
            }
          }
          if (model) {
            newHistoryRow.models.push(model);
            newHistoryRow.currentModel = model;
          }
        };
        for (var i = 0; i < oldHistory.length; i++) {
          var _ret = _loop3();
          if (_ret === "break") break;
        }
      }
    }
  }, {
    key: "removeRuleFromRows",
    value: function removeRuleFromRows() {
      var _context24;
      (0, _forEach["default"])(_context24 = this.rows).call(_context24, function (r) {
        if (r.rule) delete r.rule;
      });
    }
  }, {
    key: "recompute",
    value: function recompute(data) {
      var _this4 = this;
      var overwriteImg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (data.listid) this.listid = data.listid;
      if (data.campaign) this.campaign = data.campaign;
      if (data.delivery) this.delivery = data.delivery;
      if (data.globalPriceExtras) this.globalPriceExtras = data.globalPriceExtras;
      if (data.rows) {
        var _context25;
        (0, _forEach["default"])(_context25 = data.rows).call(_context25, function (r) {
          if (r.wallItem) return;
          var row = _this4.getRowByUid(r.uniqueid);
          if (!row) throw 'Missing row from recompute price';
          row.currency = r.currency;
          row.boxid = r.boxid;
          if (r.regtrad) row.regtrad = r.regtrad;
          if (r.img && overwriteImg) row.img = r.img;
          if (!row.erp.length) {
            row.setErp(r.erp);
            return;
          }
          for (var i = 0; i < row.erp.length; i++) {
            var erp = row.erp[i];
            var newErp = new _Erp.Erp(r.erp[i]);
            erp.bop = newErp.bop;
            erp.bom = newErp.bom;
            erp.camp = newErp.camp;
            erp.taxes = newErp.taxes;
            erp.desFromTable = newErp.desFromTable;
            erp.desTrad = newErp.desTrad;
            erp.customerFields = newErp.customerFields;
            erp.level = newErp.level;
            erp.dl = newErp.dl;
            erp.da = newErp.da;
            erp.dp = newErp.dp;
            erp.varHeadDiff = newErp.varHeadDiff;
            erp.vartrad = newErp.vartrad;
            erp.supplier = newErp.supplier;
            erp.supplierCod = newErp.supplierCod;
            erp.visible = newErp.visible;
            erp.alternativeCode = newErp.alternativeCode;
            erp.customDataFe = newErp.customDataFe;
            erp.punit = newErp.punit;
            erp.sctot = newErp.sctot;
          }
          for (var _i6 = row.erp.length; _i6 < r.erp.length; _i6++) {
            var _newErp = new _Erp.Erp(r.erp[_i6]);
            row.erp.push(_newErp);
          }
        });
      }
    }
  }, {
    key: "setClassicPlacerChild",
    value: function setClassicPlacerChild(fatherID, childID, idSlot, slotType) {
      var inserted = false;
      var fatherRow = null;
      var childRow = null;
      var foundAll = false;
      for (var i = 0; i < this.rows.length && !foundAll; i++) {
        if (this.rows[i].uniqueid == fatherID) {
          fatherRow = this.rows[i];
        }
        if (this.rows[i].uniqueid == childID) {
          childRow = this.rows[i];
        }
        if (fatherRow && childRow) {
          foundAll = true;
        }
      }
      if (foundAll && fatherRow.isSlotFree(idSlot, slotType) && childRow.father == null) {
        fatherRow.clPlacerChilds.push(new _RowSlot.RowSlot(childID, idSlot, slotType));
        childRow.father = new _RowSlot.RowSlot(fatherID, idSlot, slotType);
        inserted = true;
      }
      return inserted;
    }
  }, {
    key: "moveClassicPlacerChild",
    value: function moveClassicPlacerChild(newFatherID, childID, idSlot, slotType) {
      var inserted = false;
      if (newFatherID == childID) {
        console.log("Same ID for father and child");
        inserted = false;
      } else {
        var _context26;
        var row = this.getRowByUid(childID);
        var fatherRow = this.getRowByUid(row.father.idRow);
        var foundID = -1;
        for (var i = 0; i < fatherRow.clPlacerChilds.length && foundID == -1; i++) {
          if (fatherRow.clPlacerChilds[i].idRow == childID) {
            foundID = i;
          }
        }
        row.father = null;
        (0, _splice["default"])(_context26 = fatherRow.clPlacerChilds).call(_context26, foundID, 1);
        inserted = this.setClassicPlacerChild(newFatherID, childID, idSlot, slotType);
      }
      return inserted;
    }
  }, {
    key: "addRenderPrints",
    value: function addRenderPrints(printObj) {
      var _context27;
      var item = (0, _find["default"])(_context27 = this.renderPrints).call(_context27, function (r) {
        return printObj.attachUrl === r.attachUrl;
      });
      if (item) throw 'this item already exist';else this.renderPrints.push(printObj);
    }
  }, {
    key: "removeRenderPrint",
    value: function removeRenderPrint(print) {
      var _context28, _context29;
      var index = (0, _indexOf["default"])(_context28 = this.renderPrints).call(_context28, print);
      if (index > -1) return (0, _splice["default"])(_context29 = this.renderPrints).call(_context29, index, 1);else return null;
    }
  }, {
    key: "setEnvWall",
    value: function setEnvWall(envWall) {
      this.envWall = envWall;
    }
  }, {
    key: "hasDiscount",
    value: function hasDiscount() {
      var discounts = false;
      var piecesRows = this.rows;
      for (var i = 0; i < piecesRows.length; i++) {
        if (!piecesRows[i].erp) continue;
        if (piecesRows[i].erp.length > 0 && piecesRows[i].erp[0].sctot > 0) {
          discounts = true;
          break;
        }
      }
      return discounts;
    }
  }, {
    key: "hasTaxes",
    value: function hasTaxes() {
      var taxes = false;
      var piecesRows = this.rows;
      for (var i = 0; i < piecesRows.length; i++) {
        var _context30;
        if (!piecesRows[i].erp || piecesRows[i].erp.length < 1) continue;
        if ((0, _find["default"])(_context30 = piecesRows[i].erp).call(_context30, function (erp) {
          return erp.taxes ? erp.taxes.length > 0 : false;
        })) {
          taxes = true;
          break;
        }
      }
      return taxes;
    }
  }, {
    key: "createMemento",
    value: function createMemento() {
      var _context31,
        _this5 = this;
      var st = {};
      (0, _forEach["default"])(_context31 = (0, _keys["default"])(this)).call(_context31, function (k) {
        var _context32;
        if ((0, _indexOf["default"])(_context32 = ['currentrow', 'uniqueid', 'rows', 'envWall', 'jobs', 'tops', 'eval3dtops', 'eval3dwall', 'history']).call(_context32, k) > -1) {
          switch (k) {
            case 'rows':
              {
                var rows = _this5[k];
                var list = [];
                (0, _forEach["default"])(rows).call(rows, function (r) {
                  list.push(r.createMemento().getState());
                });
                st[k] = list;
                break;
              }
            default:
              {
                if ((0, _typeof2["default"])(_this5[k]) === 'object') {
                  st[k] = JSON.parse((0, _stringify["default"])(_this5[k]));
                } else {
                  st[k] = _this5[k];
                }
              }
          }
        }
      });
      return new _patterns.Memento(st);
    }
  }, {
    key: "setStatus",
    value: function setStatus(st) {
      var _context33,
        _this6 = this;
      (0, _forEach["default"])(_context33 = (0, _keys["default"])(st)).call(_context33, function (k) {
        if (_this6[k] == null || _this6[k] == undefined) {
          return;
        }
        switch (k) {
          case 'rows':
            {
              var tempRows = _this6.rows;
              var rows = st[k];
              _this6.rows = [];
              var _loop4 = function _loop4(i) {
                var row;
                var sameRow = (0, _find["default"])(tempRows).call(tempRows, function (r) {
                  return r.uniqueid === rows[i].uniqueid;
                });
                if (sameRow) {
                  sameRow.mergeJson(rows[i]);
                  row = sameRow;
                } else row = new _ProjectRow.ProjectRow(rows[i]);
                if (rows[i].rule) {
                  row.rule = new _Rule.Rule(rows[i].rule);
                }
                _this6.rows.push(row);
              };
              for (var i = 0; i < rows.length; i++) {
                _loop4(i);
              }
              break;
            }
          default:
            {
              if (st[k] === undefined) {
                _this6[k] = undefined;
              } else if (st[k] === null) {
                _this6[k] = null;
              } else if ((0, _typeof2["default"])(st[k]) === 'object') {
                (0, _assign["default"])(_this6[k], st[k]);
              } else {
                _this6[k] = st[k];
              }
            }
        }
      });
    }
  }], [{
    key: "createNewRow",
    value: function createNewRow() {
      return new _ProjectRow.ProjectRow(null);
    }
  }, {
    key: "getRowData",
    value: function getRowData(row) {
      var forced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var placerIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
      return _ProjectRow.ProjectRow.getRowData(row, forced, placerIndex);
    }
  }, {
    key: "baserowdata",
    value: function baserowdata(row) {
      return _ProjectRow.ProjectRow.baserowdata(row);
    }
  }]);
  return Project;
}();
exports.Project = Project;
//# sourceMappingURL=Project.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/classes/Project.js
// module id = 1265
// module chunks = 142